const convertForRead = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    if (value === 'undefined') {
      return undefined;
    }

    return value;
  }
};

const convertForStorage = (value) => {
  if (typeof value === 'object' && !Array.isArray(value)) {
    return JSON.stringify(value);
  }

  return value;
};

export default {
  get isSupported() {
    const type = 'localStorage';
    const storage = window[type];

    try {
      const keyValue = '__storage_test__';
      storage.setItem(keyValue, keyValue);
      storage.removeItem(keyValue);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage.length !== 0
      );
    }
  },

  getItem(key) {
    return convertForRead(window.localStorage.getItem(key));
  },

  setItem(key, value) {
    return window.localStorage.setItem(key, convertForStorage(value));
  },
};
